'use strict';

import FormService from "./form-service";

class Modal {

    get modalContentPlaceholder() {
        return '...';
    }

    get template() {
        return `
<div id="${this.modalId}"
     class="modal fade"
     data-backdrop="static"
     tabindex="-1"
     role="dialog"
     aria-labelledby="exampleModalLabel"
     aria-hidden="true"
     >
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="${this.modalId}-label"></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div id="${this.modalId}-content" class="modal-body">
        ${this.modalContentPlaceholder}
      </div>
    </div>
  </div>
</div>
`;
    }

    constructor() {
        this.isPreviousRequestResolved = true;
    }

    setTriggerSelector(modalTriggerSelector) {
        this.modalTriggerSelector = modalTriggerSelector;
        return this;
    }

    setModalId(modalId) {
        this.modalId = modalId;
        return this;
    }

    setModalWrapperId(modalWrapperId) {
        this.modalWrapperId = modalWrapperId;
        return this;
    }

    setUpListenersForm() {
        $(document).on('click', this.modalTriggerSelector, event => {
            this.handleOpenModalForm(event);
        });
        return this;
    }

    setUpListenersContent() {
        $(document).on('click', this.modalTriggerSelector, event => {
            this.handleOpenModalContent(event);
        });
        return this;
    }

    /**
     * Gets data from element that triggered modal (url, title)
     * Eg. <button data-url="example.com"
     *             data-title="Example title>
     *       Open modal
     *     </button>
     * @param htmlElement
     */
    handleTriggerElementData(htmlElement) {
        if (! $(htmlElement).hasClass(this.modalTriggerSelector)){
            htmlElement = $(htmlElement).closest(this.modalTriggerSelector);
        }
        const element = $(htmlElement);
        $(`#${this.modalId}-label`).html(element.data('title'));
        this.url = element.data('url');
    }

    handleOpenModalForm(event) {
        this.handleTriggerElementData(event.target);
        FormService
            .getForm(this.url)
            .done(form => this.renderForm(form));
    }

    handleOpenModalContent(event) {
        this.handleTriggerElementData(event.target);
        let self = this;
        $.ajax({
            url: this.url,
            type: 'get',
        }).done(function (response) {
            self.renderContent(response)
        });
    }

    render() {
        $(`#${this.modalWrapperId}`).html(this.template);
        $(`#${this.modalId}`).on('hidden.bs.modal', () => {
            this.cleanModalContent();
            $(`#${this.modalId}`).removeClass('show');
        });
        $(`#${this.modalId}`).on('modal.afterPostDone', () => {
            this.cleanModalContent();
        });
        $('button.close').on('click', () => {
            this.cleanModalContent();
        })
    }

    cleanModalContent() {
        $(`#${this.modalId}-content`).html(this.modalContentPlaceholder);
        this.isPreviousRequestResolved = true;
    }

    renderContent(content) {
        this.isPreviousRequestResolved = true;
        $(`#${this.modalId}-content`).html(content);

        $(`#${this.modalId}`).trigger('modal.afterRenderContent');

    }

    renderForm(content) {
        this.isPreviousRequestResolved = true;
        $(`#${this.modalId}-content`).html(content);

        $(`#${this.modalId}`).trigger('modal.afterRenderForm');
        this.addSubmitListener();
    }

    addSubmitListener() {
        const form = $(`#${this.modalId}-content form`);
        if (form.length) {
            form.on('submit', event => {
                event.preventDefault();
                if (this.isPreviousRequestResolved) {
                    this.isPreviousRequestResolved = false;
                    this.handleFormSubmit(event);
                }
            });
        }
    }

    handleFormSubmit(event) {
        FormService
            .postForm(this.url, event.target)
            .done((responseText, jqXHR, response) => {
                if (response.status === 206){
                    this.renderContent(responseText);
                }else{
                    $(`#${this.modalId}`).trigger('modal.afterPostDone', [response.status, responseText]);
                }
            })
            .fail(error => {
                this.renderForm(error.responseText);
            });
    }
}

export default Modal;


// WEBPACK FOOTER //
// ./assets/js/utils/modal.js